// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  content-background-color: white;
}
:host ion-title {
  text-align: start;
  padding-inline: 3em;
}
:host ion-item.chat-row ion-row {
  width: 100%;
}
:host ion-textarea {
  overflow-y: scroll;
}
:host textarea.text-input {
  overflow: auto !important;
}
:host ion-footer.chat-footer ion-button {
  --color: #808080;
  margin: 0 auto;
  width: 100%;
}
:host ion-item-option {
  background: white;
  color: #808080;
  font-size: 1.2em;
}
:host .option {
  white-space: normal;
  margin-right: 4px;
  /*background: #63636340 !important;*/
  background: transparent;
  border: 1px solid #1884d4 !important;
  color: #1884d4 !important;
  font-size: 1rem;
  margin-top: 5px;
  padding: 8px;
  cursor: pointer;
}
:host .option-title {
  color: #1884d4 !important;
}
:host .option-container {
  margin-bottom: 15px;
  margin-left: 45px;
}
:host .options-container {
  width: 100%;
}
:host .contact-container {
  width: calc(100% - 47px);
  margin-bottom: 15px;
  margin-left: 45px;
}
:host .page-container {
  margin-bottom: 15px;
  margin-left: 45px;
}
:host .page-container ion-button {
  width: 100%;
  white-space: normal;
}
:host .contact-container img {
  max-height: 10em;
  object-fit: cover;
}
:host .contact-container .card-title {
  padding: 0em 1em;
  margin-bottom: 1em;
  font-weight: bold;
  font-size: 1rem;
}
:host .contact-container .card-subtitle {
  padding: 0em 1em;
}
:host .contact-container .card-subtitle:last-child {
  padding: 0em 1em;
  margin-bottom: 1em;
}
:host .contact-container .role {
  font-size: 1rem;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/chat-pages/full-screen-chat/full-screen-chat.page.scss"],"names":[],"mappings":"AAAA;EAWI,+BAAA;AATJ;AADE;EACE,iBAAA;EACA,mBAAA;AAGJ;AAAI;EACE,WAAA;AAEN;AAIE;EACE,kBAAA;AAFJ;AAIE;EACE,yBAAA;AAFJ;AAKI;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AAHN;AAME;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AAJJ;AAME;EACE,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,uBAAA;EACA,oCAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAJJ;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,mBAAA;EACA,iBAAA;AANJ;AASE;EACE,WAAA;AAPJ;AAUE;EACE,wBAAA;EACA,mBAAA;EACA,iBAAA;AARJ;AAWE;EACE,mBAAA;EACA,iBAAA;AATJ;AAUI;EACE,WAAA;EACA,mBAAA;AARN;AAYE;EACE,gBAAA;EACA,iBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAXJ;AAcE;EACE,gBAAA;AAZJ;AAcE;EACE,gBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,eAAA;EACA,eAAA;AAbJ","sourcesContent":[":host {\n  ion-title {\n    text-align: start;\n    padding-inline: 3em;\n  }\n  ion-item.chat-row {\n    ion-row {\n      width: 100%;\n    }\n  }\n  content: {\n    background-color: white;\n  }\n  ion-textarea {\n    overflow-y: scroll;\n  }\n  textarea.text-input {\n    overflow: auto !important;\n  }\n  ion-footer.chat-footer {\n    ion-button {\n      --color: #808080;\n      margin: 0 auto;\n      width: 100%;\n    }\n  }\n  ion-item-option {\n    background: white;\n    color: #808080;\n    font-size: 1.2em;\n  }\n  .option {\n    white-space: normal;\n    margin-right: 4px;\n    /*background: #63636340 !important;*/\n    background: transparent;\n    border: 1px solid #1884d4 !important;\n    color: #1884d4 !important;\n    font-size: 1rem;\n    margin-top: 5px;\n    padding: 8px;\n    cursor: pointer;\n  }\n\n  .option-title {\n    color: #1884d4 !important;\n  }\n\n  .option-container {\n    margin-bottom: 15px;\n    margin-left: 45px;\n  }\n\n  .options-container {\n    width: 100%;\n  }\n\n  .contact-container {\n    width: calc(100% - 47px);\n    margin-bottom: 15px;\n    margin-left: 45px;\n  }\n\n  .page-container {\n    margin-bottom: 15px;\n    margin-left: 45px;\n    ion-button {\n      width: 100%;\n      white-space: normal;\n    }\n  }\n\n  .contact-container img {\n    max-height: 10em;\n    object-fit: cover;\n  }\n\n  .contact-container .card-title {\n    padding: 0em 1em;\n    margin-bottom: 1em;\n    font-weight: bold;\n    font-size: 1rem;\n  }\n\n  .contact-container .card-subtitle {\n    padding: 0em 1em;\n  }\n  .contact-container .card-subtitle:last-child {\n    padding: 0em 1em;\n    margin-bottom: 1em;\n  }\n\n  .contact-container .role {\n    font-size: 1rem;\n    margin-top: 8px;\n  }\n\n  \n  \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
